var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_13627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 4.5H13.5C11.85 4.5 10.5 5.85 10.5 7.5V10.5C5.55 10.5 1.5 14.55 1.5 19.5V28.5H4.5C4.5 30.9855 6.5145 33 9 33C11.4855 33 13.5 30.9855 13.5 28.5H19.5C19.5 30.9855 21.5145 33 24 33C26.4855 33 28.5 30.9855 28.5 28.5H31.5C33.15 28.5 34.5 27.15 34.5 25.5V7.5C34.5 5.85 33.15 4.5 31.5 4.5ZM33 25.5C33 26.3272 32.3272 27 31.5 27H28.2383C27.6195 25.2533 25.9583 24 24 24C22.0417 24 20.3798 25.2533 19.7618 27H13.5C13.407 27 13.317 26.9888 13.2285 26.9723C12.9735 26.2665 12.5483 25.644 12 25.152V7.5C12 6.67275 12.6727 6 13.5 6H31.5C32.3272 6 33 6.67275 33 7.5V25.5ZM27 28.5C27 30.1545 25.6545 31.5 24 31.5C22.3455 31.5 21 30.1545 21 28.5C21 26.8455 22.3455 25.5 24 25.5C25.6545 25.5 27 26.8455 27 28.5ZM12 28.5C12 30.1545 10.6545 31.5 9 31.5C7.3455 31.5 6 30.1545 6 28.5C6 26.8455 7.3455 25.5 9 25.5C10.6545 25.5 12 26.8455 12 28.5ZM10.5 12V18.75H3.03825C3.4155 14.9655 6.618 12 10.5 12ZM3 27V20.25H10.5V24.2617C10.0305 24.0952 9.5265 24 9 24C7.04175 24 5.37975 25.2533 4.76175 27H3Z",
    fill: "#FF7B9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_13627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListicon);
export default __webpack_public_path__ + "static/media/listicon.b7030e694e1f6efa7ec7c11e8ca6a8ca.svg";
export { ForwardRef as ReactComponent };